import { backgroundColorMasterHost } from 'View/schedule-generate/const';

const getRulesetDetailResponse = (response) => {
  const result = {
    ...response?.scheduleRuleset,
    users: response?.scheduleRuleset?.users.map((user, index) => {
      const indexColor = index % 10;
      return {
        ...user,
        bgColor: backgroundColorMasterHost[indexColor],
      };
    }),
  };
  return result;
};

export default getRulesetDetailResponse;
